import { Routes } from '@angular/router';

import { Landing } from '@/landing/landing';
import { ServiceDetailComponent } from '@/landing/components/service-detail/service-detail.component';


export const appRoutes: Routes = [
    
    { path: '', component: Landing },

    // Nueva ruta dinámica
    { path: 'service/:id', component: ServiceDetailComponent },

    // Mantén esto temporalmente si necesitas consultar la demo en desarrollo
    {
        path: 'demo',
        loadChildren: () => import('./app/template-demo/pages/pages.routes') 
    },
    { path: 'notfound', loadComponent: () => import('./app/template-demo/pages/notfound/notfound').then(c => c.Notfound) },
    { path: '**', redirectTo: '/notfound' }
];
